import script from "./DiagAttemptsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagAttemptsPanel.vue?vue&type=script&setup=true&lang=js"

import "./DiagAttemptsPanel.vue?vue&type=style&index=0&id=1b9362cc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9362cc"]])

export default __exports__